import PropTypes from 'prop-types'
import React from 'react'
import Base from './BaseContainer'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import { clearHttpStatus } from '../services/manager/HttpManager'

import Crouton from '../components/Crouton/Crouton'

import Constants from '../services/constants/Constants'

let timeout = null

class CroutonContainer extends Base {

  constructor () {
    super()
    this._bind('_handleClick')
    this.state = {
      showCrouton: false,
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.httpStatus !== '' && nextProps.text !== '') {
      this.setState({showCrouton: true})
      if (nextProps.httpStatus !== Constants.ActionsConstants.HTTP.ERROR) {
        if (timeout !== null) clearTimeout(timeout)
        if (nextProps.text !== I18n.t('Error.Croutons.reinitPassword')) {
          timeout = setTimeout(() => {
            this._handleClick()
          }, 2000)
        }
      }
    }
  }

  _handleClick () {
    this.setState({
      showCrouton: false,
    })
    this.props.clearStatus()
    timeout = null
  }

  render () {
    return (
      <Crouton
          message={this.props.text}
          type={this.props.httpStatus}
          onCloseClick={this._handleClick}
          isDisplayed={this.state.showCrouton}/>
    )
  }

}

CroutonContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  httpStatus: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  clearStatus: PropTypes.func.isRequired,
}

const mapStateToProps = ({ http: { httpStatus, text } }) => ({
  httpStatus,
  text,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch: dispatch,
  clearStatus () {
    clearHttpStatus(dispatch).clear()
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(CroutonContainer)
